<template>
  <div class="contractManagementDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <van-field
        v-model="form.CustomerNumber"
        :label="$t.contractManagement.customerNumber"
        label-class="number-label"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(form.CustomerNumber)"
            :disabled="!form.CustomerNumber ? true : false"
            native-type="button"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="form.ContractNo"
        :label="$t.contractManagement.contractNumber"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.ContractName"
        :label="$t.contractManagement.contractName"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.ContractConclusion"
        :label="$t.contractManagement.conclusion"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.PerformColleague"
        :label="$t.contractManagement.dIssueBy"
        :placeholder="$t.meta.input"
      />

      <van-field
        readonly
        clickable
        :value="form.ExpiryDate"
        :label="$t.contractManagement.validity"
        :placeholder="$t.meta.select"
        @click="onShowCalendar('showCalendar1')"
      />

      <van-field
        v-model="form.PaymentCreditDays"
        :label="$t.contractManagement.creditDays"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.CreditAmount"
        :label="creditAmountLabel"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <div class="multi-table" v-if="form.FileList">
        <van-field name="stepper" :label="$t.contractManagement.attachmentList">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.FileList.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.FileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="filePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader
                :after-read="afterRead1"
                accept=".pdf"
                @click-upload="uploaderClick(index)"
              >
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                >
                </van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>

      <van-popup v-model="showCalendar1" position="bottom">
        <van-datetime-picker
          type="date"
          :title="$t.contractManagement.validity"
          :formatter="formatter"
          :confirm-button-text="$t.meta.confirm"
          :cancel-button-text="$t.meta.cancel"
          @confirm="onConfirmCalendar($event)"
          @cancel="showCalendar1 = false"
          :min-date="currentDate"
          v-model="selectDate"
        />
      </van-popup>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Popup,
  DatetimePicker,
  Uploader,
  Stepper,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Popup)
  .use(DatetimePicker)
  .use(Uploader)
  .use(Stepper);

export default {
  name: "contractManagementDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      settlementCurrency: JSON.parse(localStorage.getItem("auth")).userInfo
        .SettlementCurrency,
      isEdit: false,
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      creditAmountLabel: "",
      //日期
      selectDate: new Date(),
      currentDate: "",
      showCalendar1: false,
      //文件
      filesIndex: 0,
    };
  },
  created() {
    const { IsEdit } = this.$route.query;
    this.isEdit = IsEdit;
    if (IsEdit) {
      var data = JSON.parse(localStorage.getItem("contractManagementDetail"));
      this.form = data;
    } else {
      this.form = {
        ContractId: "",
        CustomerNumber: "",
        ContractNo: "",
        ContractName: "",
        ContractConclusion: "",
        PerformColleague: "",
        ExpiryDate: "",
        PaymentCreditDays: "",
        CreditAmount: "",
        FileList: [],
      };
    }

    if (this.settlementCurrency) {
      this.creditAmountLabel =
        this.$t.contractManagement.creditAmount +
        " " +
        this.$t.contractManagement.creditLimit +
        " (" +
        this.settlementCurrency +
        ")";
    } else {
      this.creditAmountLabel =
        this.$t.contractManagement.creditAmount +
        " " +
        this.$t.contractManagement.creditLimit;
    }
  },
  methods: {
    onConfirmCalendar(date) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      this.form.ExpiryDate = formatDate(date);
      this.showCalendar1 = false;
    },
    onShowCalendar(param) {
      var date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = date;
      this[param] = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    filePreview(file) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.gotoPay, {
        url: file,
      });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      param.Uploader = this.UserId;
      var request = null;
      if (this.isEdit) {
        request = this.$api.customerManagement.editContractManagement(param);
      } else {
        request = this.$api.customerManagement.addContractManagement(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    handleDelByIndex(index) {
      if (this.form.FileList.length > 0) {
        this.form.FileList.splice(index, 1);
      }
    },
    handleDel() {
      if (this.form.FileList.length > 0) {
        this.form.FileList.pop();
      }
    },
    handleAdd() {
      this.form.FileList.push({
        FileAddress: "",
      });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .UploadPdfFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.FileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.contractManagementDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
}
</style>
